import { type CSSProperties } from 'react';

export function Placeholder({
  style,
  stopColor1 = 'rgba(100,100,100,0.1)',
  stopColor2 = 'rgba(100,100,100,0.24)',
}: {
  style?: CSSProperties;
  stopColor1?: string;
  stopColor2?: string;
}) {
  return (
    <div style={{ position: 'relative', overflow: 'hidden' }}>
      <svg
        style={style}
        width="474"
        height="16"
        viewBox="0 0 474 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="relative"
      >
        <defs>
          <linearGradient id="shimmer" x1="-100%" x2="100%" y1="0" y2="0">
            <stop offset="0%" stopColor={stopColor1}>
              <animate attributeName="offset" values="-2; 1" dur="2s" repeatCount="indefinite" />
            </stop>
            <stop offset="50%" stopColor={stopColor2}>
              <animate
                attributeName="offset"
                values="-1.5; 1.5"
                dur="2s"
                repeatCount="indefinite"
              />
            </stop>
            <stop offset="100%" stopColor={stopColor1}>
              <animate attributeName="offset" values="-1; 2" dur="2s" repeatCount="indefinite" />
            </stop>
          </linearGradient>
        </defs>

        <rect width="42" height="16" rx="8" fill="url(#shimmer)" />
        <rect x="54" width="338" height="16" rx="8" fill="url(#shimmer)" />
        <rect x="404" width="42" height="16" rx="8" fill="url(#shimmer)" />
        <rect x="458" width="16" height="16" rx="8" fill="url(#shimmer)" />
      </svg>
    </div>
  );
}
